<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='code_sn' :columns='columns' :data-source='data'>
    <template v-slot:gift_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.exchange_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2" style="width: 320px;">{{record.exchange_name}}</p>
        </template>
      </a-card-meta>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getTransferWarehousingCode,getOutWarehousingCode } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  let defSearch = {
    page: 1,
    limit: 5,
  };
  export default {
    components: {},
    name: "shippingCode",
    props: {
      id: { // 商品id
        type: Number
      },
      sn: { // 单号或者单id
        type: String
      },
      sku_sn: { // 商品规格
        type: String
      },
      showLast: { // 是否显示‘入库仓库’
        type: Boolean
      },
      type: { // 单据来源
        type: String
      }
    },
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 0,
        columns: [
          {
            title: "二维码号",
            dataIndex: "code_sn",
            key: "code_sn"
          },
          {
            title: "二维码类型",
            dataIndex: "code_type_text",
            key: "code_type_text",
          },
          {
            title: "商品名称",
            dataIndex: "product_name",
            key: "product_name"
          },
          {
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "商品数量",
            dataIndex: "code_num",
            key: "code_num",
          },
          {
            title: "入库仓库",
            dataIndex: "warehouse_position_name",
            key: "warehouse_position_name",
          }
        ]
      });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async () => {
        state.listLoading = true;
        let res
        if(props.type == 'allocation'){
          res = await getTransferWarehousingCode({ ...search.value, id: props.id }).then((res) => res.data);
        }else if(props.type == 'outbound'){
          res = await getOutWarehousingCode({ ...search.value, sn:props.sn,product_id: props.id,product_sku_sn:props.sku_sn?props.sku_sn:0 }).then((res) => res.data);
        }else{
          res = await getTransferWarehousingCode({ ...search.value, transfer_warehousing_sn: props.sn,product_id:props.id,product_sku_sn:props.sku_sn?props.sku_sn:0 }).then((res) => res.data);
        }
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        if(!props.showLast){
          var index = state.columns.findIndex(v=> v.title == '入库仓库')
          if(index){
            state.columns.splice(index,1)
          }
        }
        initData();
      });
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>